import { render, staticRenderFns } from "./Componentes.vue?vue&type=template&id=5e5b0f36&"
import script from "./Componentes.vue?vue&type=script&lang=js&"
export * from "./Componentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports